import { inject } from "mobx-react";
import React, { useState } from "react";
import { Route, Switch, useRouteMatch } from "react-router";
import { CallLogSchema } from "./schema";
import { IndexView } from "lego-gui-lib/lib";
import {
  TabContentContainer,
  TabTitleContainer,
  TabViewContainer
} from "../../common/tabContainers";
import { toolbarButtonsWithExports } from "./toolbarButtonsExportAll";
import { observer } from "mobx-react-lite";
import { Loader } from "../../common/loadingComponent";
import { makeStyles, Theme } from "@material-ui/core";
import { createStyles } from "@material-ui/styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0, 0, 0, 0.3)"
    }
  })
);

export const CallLogViewComponent = () => {
  const match = useRouteMatch();
  const baseUrl = match.path;

  return (
    <Switch>
      <Route exact={true} path={baseUrl} component={Index} />
    </Switch>
  );
};

const injectDataSource = (comp: any) =>
  inject("callLog", "auth", "language", "i18n")(observer(comp));

const IndexSchema = CallLogSchema;
export const Index = injectDataSource(({ callLog, i18n, ...rest }: any) => {
  const title = i18n.t("hns:callLog:domain", { count: 2 });

  const [showLoader, setShowLoader] = useState<boolean>(false);

  const classes = useStyles();

  const showLoaderHandler = () => {
    setShowLoader(true);
  };

  const hideLoaderHandler = () => {
    setShowLoader(false);
  };

  const indexView = (
    <IndexView
      dataSource={callLog.listDataSource}
      {...rest}
      title={title}
      titleButtons={() => <></>}
      toolbarButtons={toolbarButtonsWithExports(
        showLoaderHandler,
        hideLoaderHandler
      )}
      rowButtons={{ edit: false, delete: false, copy: false, export: true }}
      columns={IndexSchema}
      titleContainer={TabTitleContainer}
      viewContainer={TabViewContainer}
      contentContainer={TabContentContainer}
    />
  );

  return (
    <>
      {showLoader && (
        <>
          <div className={classes.wrapper}>
            <Loader />
          </div>
          {indexView}
        </>
      )}
      {!showLoader && indexView}
    </>
  );
});
